const { BaseClient, setupClient } = require('./base-client')

const { inboxesUrl } = require('sci/utils')

class Client extends BaseClient {
    url (path) {
        return inboxesUrl(path)
    }
}

module.exports = setupClient(Client)



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/inboxes-client.js